import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import {
    mainViewState,
    upperSideViewState,
    lowerSideViewState,
} from '~/state/atoms/engineAtoms';
import { primaryImageState } from '~/state/atoms/image/imageAtoms';
import { viewportOrientationOrderState } from '~/state/atoms/viewerAtoms';
import { PlaneView } from '~/engine/view/views/PlaneView';

/**
 * Handles updating viewport orientations when the orientation order
 * or primary image changes.
 *
 * Derives the view orientation from the image Grid's orientation
 * matrix, correctly handling all axis-aligned patient positions
 * (HFS, HFP, FFS, FFP). For oblique images, falls back to the
 * standard HFS orientation.
 */
export function useViewportOrientationHandler() {
    const primaryImage = useRecoilValue(primaryImageState);
    const viewportOrientationOrder = useRecoilValue(
        viewportOrientationOrderState
    );

    const mainView = useRecoilValue(mainViewState);
    const upperSideView = useRecoilValue(upperSideViewState);
    const lowerSideView = useRecoilValue(lowerSideViewState);

    useEffect(() => {
        const imageGrid = primaryImage?.grid;
        const views = [mainView, upperSideView, lowerSideView];

        views.forEach((view, idx) => {
            if (!view) {
                return;
            }
            const viewType = viewportOrientationOrder[idx];
            const orientationMatrix = imageGrid
                ? PlaneView.computeViewOrientation(imageGrid, viewType)
                : PlaneView.ORIENTATIONS[viewType];
            view.setOrientation(orientationMatrix, viewType);
            view.updateView();
        });
    }, [
        primaryImage,
        viewportOrientationOrder,
        mainView,
        upperSideView,
        lowerSideView,
    ]);
}
